function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_126_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_128_",
  d: "M212.756,0h-212.244c0,164.342,0,328.297,0,492.159h112.33l28.869-156.447c18.161-54.682,71.045-184.5,71.045-335.712Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_127_",
  d: "M279.403,0c0,151.212,52.884,281.03,67.946,331.837l31.968,160.321h112.331c0-163.852,0-327.817,0-492.159h-212.245Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg811(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.15899658203125 492.15899658203125",
    style: {
      enableBackground: "new 0 0 492.159 492.159"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 492.15899658203125,
    height: 492.15899658203125,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("defs", {
    id: "svgEditorDefs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svgEditorClosePathDefs",
    style: {
      stroke: "black",
      strokeWidth: 1,
      fill: "rosybrown"
    }
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg811);
export default __webpack_public_path__ + "static/media/8_1_1.f3608c1f.svg";
export { ForwardRef as ReactComponent };